import { GUIDE_STORY_IDS, type GuideStoryId } from '@redevicer/shared'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { getStoryCoverUrl } from '../utils/homeStoryImages'

type Props = {
  onOpenFull: (id: GuideStoryId) => void
}

export default function GuideArticlesList({ onOpenFull }: Props) {
  const { t } = useTranslation()

  return (
    <div className="vc-news-preview-wrap vc-news-preview-wrap--articles">
      <div className="vc-news-preview-grid">
        {GUIDE_STORY_IDS.map((id, index) => (
          <article
            key={id}
            className="vc-news-preview-card"
            data-story={id}
            style={{ '--card-i': index } as CSSProperties}
          >
            <button type="button" className="vc-news-preview-media" onClick={() => onOpenFull(id)}>
              <span className="vc-news-preview-media-inner">
                <img
                  src={getStoryCoverUrl(id, 640)}
                  alt=""
                  className="vc-news-preview-cover"
                  loading="lazy"
                  decoding="async"
                />
                <span className="vc-news-preview-media-shade" aria-hidden="true" />
              </span>
            </button>
            <div className="vc-news-preview-body">
              <time className="vc-news-preview-date">{t(`vc.story.${id}Date`)}</time>
              <h4 className="vc-news-preview-title">{t(`vc.story.${id}Title`)}</h4>
              <button type="button" className="vc-news-preview-link" onClick={() => onOpenFull(id)}>
                <span>{t('vc.story.readFull')}</span>
                <span className="vc-news-preview-link-arrow" aria-hidden="true">
                  →
                </span>
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}
